import StickyBottomBar from "./StickyBottomBar";

export default StickyBottomBar;
export type { StickyBottomBarAdapterProps, StoryblokStickyBottomBarProps } from "./StickyBottomBar.d";
